var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isClosed)?_c('div',{staticClass:"sp-notice",on:{"click":function($event){_vm.isClosed = true}}},[_vm._v("\n    ※"+_vm._s(_vm.serviceName)+"はPCでのご利用を推奨しております。\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }